<script setup lang="ts">
import ShiftEmployeePanel from '../../../shifts/components/panels/ShiftEmployeePanel.vue'
import { SiteID } from '../../../sites/models/site'
import { useScheduleShiftOffersDialog } from '../../composables/useScheduleShiftOffersDialog'

const { siteId } = defineProps<{
  siteId: SiteID
}>()

const { hide, isShown, shift } = useScheduleShiftOffersDialog()
</script>

<template>
  <Dialog
    :visible="isShown"
    header="Shift Offers"
    dismissable-mask
    modal
    class="w-full max-w-screen-lg md:w-1/2"
    @update:visible="hide"
  >
    <ShiftEmployeePanel v-if="shift" :site-id="siteId" :shift="shift" />
  </Dialog>
</template>
